import React, { PropsWithChildren, useId } from 'react';
import Dialog from 'components/DesignSystem/Dialog';
import Button from 'components/DesignSystem/Button';
import './index.scss';
import DialogFooter from 'components/DesignSystem/Dialog/Footer';
import DialogBody from 'components/DesignSystem/Dialog/Body';

/** Textos opcionais do diálogo; sem eles fica o padrão de sempre ("Cancelar" / "Sim"). */
export interface ConfirmationDialogLabels {
  /** Título acima do texto (ex.: "Excluir estudo?"). */
  title?: string,
  /** Botão que confirma. Padrão: "Sim". */
  confirmLabel?: string,
  /** Botão que desiste. Padrão: "Cancelar". */
  dismissLabel?: string,
}

interface ConfirmationDialogBoxProps extends ConfirmationDialogLabels {
  open: boolean,
  confirm: () => void,
  dismiss: () => void,
}

export default function ConfirmationDialogBox(
  {
    children, open, confirm, dismiss, title, confirmLabel = 'Sim', dismissLabel = 'Cancelar',
  }: PropsWithChildren<ConfirmationDialogBoxProps>,
) {
  const titleId = useId();

  return (
    <Dialog
      open={open}
      dismiss={dismiss}
      closeButton
      centered
      className="confirmation-box"
      backdropClassName="confirmation-box-backdrop"
      labelledBy={title ? titleId : undefined}
    >
      <DialogBody>
        {title && <h2 id={titleId} className="confirmation-box-title">{title}</h2>}
        {children}
      </DialogBody>
      <DialogFooter>
        <Button onClick={dismiss}>{dismissLabel}</Button>
        <Button
          onClick={() => {
            // O modal segue clicável durante a animação de saída: o 2º clique não confirma de novo
            if (!open) return;
            confirm();
            dismiss();
          }}
        >
          {confirmLabel}
        </Button>
      </DialogFooter>
    </Dialog>
  );
}
